var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNebl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.282 7.538c.402.24.738.576.977.978.224.404.342.86.342 1.322V22.16a2.662 2.662 0 0 1-1.32 2.3l-5.327 3.09-5.327 3.09a2.625 2.625 0 0 1-2.655 0l-5.327-3.09-5.327-3.09A2.656 2.656 0 0 1 3 22.16V9.839a2.663 2.663 0 0 1 1.32-2.3l1.3-.756L9.647 4.45l5.327-3.09a2.625 2.625 0 0 1 2.655 0l5.327 3.089 5.327 3.088zm-5.327 12.306v-7.707L16.31 8.293l-1.148.67-5.5 3.192v7.689l6.647 3.845 6.645-3.846zm-.942-.55L16.31 22.59V16l5.703-3.296v6.59z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNebl);
export default __webpack_public_path__ + "static/media/NEBL.df022bf79e6d85c14f468e60242886e5.svg";
export { ForwardRef as ReactComponent };